import React from 'react';
import { Icon } from '../Icon';
import { IconWrapper } from './elements';
export var ChipIcon = function (_a) {
    var size = _a.size, side = _a.side, src = _a.src;
    return (React.createElement(IconWrapper, { "$iconSide": side },
        React.createElement(Icon, { src: src, size: size === 'small' ? '18px' : '20px' })));
};
